export const FETCH_HELPLINES_INIT_ACTION = "FETCH_HELPLINES_INIT_ACTION";
export const FETCH_HELPLINES_SUCCESS_ACTION =
  FETCH_HELPLINES_INIT_ACTION + "_SUCCESS";
export const FETCH_HELPLINES_FAIL_ACTION = FETCH_HELPLINES_INIT_ACTION + "_ERROR";

export const ADD_HELPLINE_INIT_ACTION = "ADD_HELPLINE_INIT_ACTION";
export const ADD_HELPLINE_SUCCESS_ACTION = ADD_HELPLINE_INIT_ACTION + "_SUCCESS";
export const ADD_HELPLINE_FAIL_ACTION = ADD_HELPLINE_INIT_ACTION + "_ERROR";

export const EDIT_HELPLINE_INIT_ACTION = "EDIT_HELPLINE_INIT_ACTION";
export const EDIT_HELPLINE_SUCCESS_ACTION = EDIT_HELPLINE_INIT_ACTION + "_SUCCESS";
export const EDIT_HELPLINE_FAIL_ACTION = EDIT_HELPLINE_INIT_ACTION + "_ERROR";

export function fetchHelplines() {
  return {
    type: FETCH_HELPLINES_INIT_ACTION
  };
}

export function AddHelpline(value) {
  // console.log(value);
  return {
    type: ADD_HELPLINE_INIT_ACTION,
    value: value
  };
}

export function EditHelpline(value) {
  return {
    type: EDIT_HELPLINE_INIT_ACTION,
    value: value
  };
}

export function helplineSlectedPage(value) {
  return {
    type: FETCH_HELPLINES_INIT_ACTION,
    value: value
  };
}
